<template>
  <div>
    <!-- Text-and-Button:start -->
    <div class="flex items-baseline justify-between mt-10 relative">
      <h2 class="intro-y text-lg font-medium -top-1">
        {{ $t(`${viewRoot}.list`) }}
      </h2>
      <button type="button" class="btn btn-primary w-34 h-8" @click="newMiniGuide">
        <span>{{ $t(`${viewRoot}.new`) }}</span>
      </button>
    </div>
    <!-- Text-and-Button:end -->

    <!-- Main-container:start -->
    <div class="grid grid-cols-12 gap-6 mb-12">
      <!--Header:start-->
      <div class="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
        <p class="mr-auto">{{ $t(`${viewRoot}.description`) }}</p>
      </div>
      <!--Header:end-->

      <!-- Filters:start -->
      <div class="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
        <div class="w-full grid sm:grid-cols-2 lg:grid-cols-6 xl:grid-cols-4 gap-6 mt-3 sm:mt-0 sm:ml-auto md:ml-0">
          <!--Campo buscador-->
          <div class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
            <div class="w-full relative lg:col-span-2 xl:col-span-1 text-gray-700 dark:text-gray-300">
              <input
                type="text"
                class="form-control w-full box pr-10 placeholder-theme-13"
                :placeholder="$t(`${viewRoot}.search_text`)"
                v-model="searchInput"
                @keyup="filterMiniGuides"
              />
              <SearchIcon class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0" />
            </div>
          </div>

          <!--Selector de filtrar por categoria de mini-guias-->
          <div class="w-full relative lg:col-span-2 xl:col-span-1 text-gray-700 dark:text-gray-300">
            <TomSelect class="w-full cursor" v-model="category" @change="filterMiniGuides">
              <option value="0">{{ $t(`${viewRoot}.form.category.placeholder`) }}</option>
              <option v-for="(cat, key) in categories" :key="key" :value="cat.id">
                {{ cat.name }}
              </option>
            </TomSelect>
          </div>

          <!--Selector de filtrar por Subcategoria de mini-guias-->
          <div class="w-full relative lg:col-span-2 xl:col-span-1 text-gray-700 dark:text-gray-300">
            <TomSelect class="w-full cursor" v-model="subcategory" @change="filterMiniGuides">
              <option value="0">{{ $t(`${viewRoot}.form.subcategory.placeholder`) }}</option>
              <option v-for="(subcat, key) in subcategories" :key="key" :value="subcat.id">
                {{ subcat.name }}
              </option>
            </TomSelect>
          </div>

          <!-- seleccion  estado-->
          <div class="w-full relative text-gray-700 dark:text-gray-300">
            <TomSelect class="w-full cursor" v-model="status" @change="filterMiniGuides">
              <option value="0">{{ $t(`${viewRoot}.form.status.placeholder`) }}</option>
              <!-- Texto para mostrar 'Todos' los estados -->
              <option value="PENDING_APPROVAL">{{ $t(`${viewRoot}.to_be_approved`) }}</option>
              <option value="REJECTED">{{ $t(`${viewRoot}.disapproved`) }}</option>
              <option value="APPROVED">{{ $t(`${viewRoot}.approved`) }}</option>
            </TomSelect>
          </div>

          <!-- checkbox solo miniguias de apertura -->
          <div class="flex items-center mx-1">
            <p class="mr-3">{{ $t(`${viewRoot}.only_opening`) }}</p>
            <input type="checkbox" class="form-check-switch" v-model="onlyOpening" @change="filterMiniGuides" />
          </div>
        </div>
      </div>
      <!-- Filters:end -->

      <!-- Data-List:start -->
      <div class="intro-y col-span-12 overflow-hidden">
        <table class="table table-report -mt-2">
          <thead>
            <tr>
              <th class="whitespace-nowrap">
                <div class="grid miniGuides-grid">
                  <div>{{ $t(`${viewRoot}.table.title1`) }}</div>
                  <div>{{ $t(`${viewRoot}.table.title2`) }}</div>
                  <div>{{ $t(`${viewRoot}.table.title3`) }}</div>
                  <div>{{ $t(`${viewRoot}.table.title4`) }}</div>
                </div>
              </th>
              <th class="text-center whitespace-nowrap">
                {{ $t(`${viewRoot}.table.actions`) }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(miniGuide, miniGuideKey) in miniGuides.data" :key="miniGuideKey">
              <tr class="intro-x">
                <td>
                  <div class="grid miniGuides-grid cursor-pointer">
                    <!--Name Miniguide-->
                    <div>{{ miniGuide.technical_title }}</div>

                    <!--Category MiniGuide-->
                    <div
                      class="py-1 px-2 rounded-md text-xs text-white cursor-pointer font-medium my-1 w-max tag-category bg-custom-gray-4"
                    >
                      {{ miniGuide.category }}
                    </div>

                    <!--Subcategory Miniguide.-->
                    <div
                      class="py-1 px-2 rounded-md text-xs text-white cursor-pointer font-medium my-1 w-max tag-category bg-custom-gray-4"
                    >
                      {{ miniGuide.subcategory }}
                    </div>

                    <!--Status of the miniGuide-->
                    <div
                      class="alert show py-1 px-4 w-max h-max-content font-medium"
                      :class="{
                        'green-ok text-white': miniGuide.status === 'APPROVED',
                        'red-danger text-white': miniGuide.status === 'REJECTED',
                        'orange-medium text-black': miniGuide.status === 'PENDING_APPROVAL',
                      }"
                    >
                      {{ $t(`${viewRoot}.${getNameStatus(miniGuide.status)}`) }}
                    </div>
                  </div>
                </td>
                <!-- Section-Actions:start -->
                <td>
                  <div class="flex justify-center items-center">
                    <a class="flex items-center mr-3" href="javascript:;" @click="editMiniGuide(miniGuide.id)">
                      <CheckSquareIcon class="w-4 h-4 mr-1" />
                      {{ $t("views.edit") }}
                    </a>
                  </div>
                </td>
                <!-- Section-Actions:end -->
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <!-- Data-List:start -->
    </div>
    <!-- Main-container:end -->

    <!-- Pagination:start -->
    <div
      class="intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-nowrap items-center"
      v-if="miniGuides?.data.length > 0"
    >
      <ul class="pagination">
        <li>
          <a class="pagination__link" href="javascript:;" @click="goPage(1)">
            <ChevronsLeftIcon class="w-4 h-4" />
          </a>
        </li>
        <li>
          <a class="pagination__link" href="javascript:;" @click="goPage('prev')">
            <ChevronLeftIcon class="w-4 h-4" />
          </a>
        </li>
        <li>
          <a
            class="pagination__link"
            v-if="pagination.total_pages >= getNumberPage('first')"
            v-bind:class="{ 'pagination__link--active': pagination.page == getNumberPage('first') }"
            href="javascript:;"
            @click="goPage(getNumberPage('first'))"
            >{{ getNumberPage("first") }}</a
          >
        </li>
        <li>
          <a
            class="pagination__link"
            v-if="pagination.total_pages >= getNumberPage('second')"
            v-bind:class="{ 'pagination__link--active': pagination.page == getNumberPage('second') }"
            href="javascript:;"
            @click="goPage(getNumberPage('second'))"
            >{{ getNumberPage("second") }}</a
          >
        </li>
        <li v-if="getNumberPage('second') != getNumberPage('') && pagination.total_pages >= getNumberPage('')">
          <a
            class="pagination__link"
            v-bind:class="{ 'pagination__link--active': pagination.page == getNumberPage('') }"
            href="javascript:;"
            @click="goPage(getNumberPage(''))"
            >{{ getNumberPage("") }}</a
          >
        </li>
        <li>
          <a class="pagination__link" href="javascript:;" @click="goPage('next')">
            <ChevronRightIcon class="w-4 h-4" />
          </a>
        </li>
        <li>
          <a class="pagination__link" href="javascript:;" @click="goPage(pagination.total_pages)">
            <ChevronsRightIcon class="w-4 h-4" />
          </a>
        </li>
      </ul>

      <div class="ml-auto mr-5 text-gray-600">
        {{ $t("components.pagination.viewing", { total: miniGuides.data.length }) }}
      </div>
      <select
        class="w-20 form-select box mt-3 sm:mt-0"
        v-model="pagination.per_page"
        @change="
          () => {
            changePerPage();
          }
        "
      >
        <option>10</option>
        <option>25</option>
        <option>35</option>
        <option>50</option>
      </select>
    </div>
    <!-- Pagination:end -->
  </div>
</template>

<script>
import MiniGuidesService from "../../services/mini_guide.service";

export default {
  name: "MiniguidesList",
  data() {
    return {
      viewRoot: "views.miniguides",
      miniGuides: { data: [] },
      searchInput: "",
      showMiniGuides: [],
      // Filters:start
      category: null,
      subcategory: null,
      status: 0,
      categories: [],
      subcategories: [],
      onlyOpening: false,
      // Filters:end
      pagination: {
        page: 1,
        total_pages: 0 /* esto va a venir de la api */,
        per_page: 10,
        total: 0,
      },
      activeLang: "lang__" + (localStorage.lang ? localStorage.lang : navigator.language.split("-")[0]),
      activeLangKey: localStorage.lang ? localStorage.lang : navigator.language.split("-")[0],
    };
  },
  mounted() {
    this.getMiniGuides();
    this.getMiniGuidesCategories();
  },
  watch: {
    "$i18n.locale": function (l) {
      this.activeLangKey = l;
    },
    category: {
      immediate: true,
      handler: async function (val) {
        this.subcategory = null;
        this.getMiniGuidesSubcategories(val);
      },
    },
    date: function () {
      this.filterMiniGuides();
    },
  },
  methods: {
    async getMiniGuides() {
      const params = {
        search: this.searchInput || "",
        mini_guide_category_id: this.category || null,
        mini_guide_subcategory_id: this.subcategory || null,
        status: this.status || null,
        only_opening: this.onlyOpening,
        pagination: this.pagination,
        limit: this.pagination.per_page,
        role: "ADMIN",
      };
      this.miniGuides = await MiniGuidesService.getAll(params, localStorage.lang);
      this.pagination.total = this.miniGuides.pagination.total;
      this.pagination.total_pages = this.miniGuides.pagination.total_pages;
    },
    async getMiniGuidesCategories() {
      const response = await MiniGuidesService.getCategories();
      this.categories = response;
    },
    async getMiniGuidesSubcategories(categoryId) {
      this.subcategories = await MiniGuidesService.getSubcategories(categoryId);
    },

    newMiniGuide() {
      this.$router.push({ path: "/miniguide-new" });
    },
    filterMiniGuides() {
      this.pagination.page = 1;
      this.getMiniGuides();
    },
    editMiniGuide(id) {
      this.$router.push({ path: "/miniguide-edit", query: { id } });
    },

    // Pagination:start
    goPage: function (param) {
      if (param == "prev") {
        this.pagination.page = this.pagination.page > 1 ? this.pagination.page - 1 : 1;
      } else if (param == "next") {
        this.pagination.page =
          this.pagination.page < this.pagination.total_pages ? this.pagination.page + 1 : this.pagination.total_pages;
      } else {
        this.pagination.page = param;
      }

      this.getMiniGuides();
    },
    getNumberPage(type) {
      if (type == "first") {
        return this.pagination.page < 3 ? 1 : this.pagination.page - 1;
      } else if (type == "second") {
        return this.pagination.page > 2 ? this.pagination.page : 2;
      } else {
        return this.pagination.page > 2
          ? this.pagination.page + 1 > this.pagination.total_pages
            ? this.pagination.total_pages
            : this.pagination.page + 1
          : 3;
      }
    },
    changePerPage() {
      this.pagination.page = 1;
      this.pagination.per_page = Number(this.pagination.per_page);
      this.getMiniGuides();
    },
    filterClean() {
      this.searchInput = "";
    },
    getNameStatus(codeStatus) {
      switch (codeStatus) {
        case "APPROVED":
          return "approved";
        case "REJECTED":
          return "disapproved";
        case "PENDING_APPROVAL":
          return "to_be_approved";
        default:
          return "to_be_approved";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// checkbox color
.dark .form-check-switch:checked {
  background-color: rgba(41, 49, 69, 1);
  border-color: rgba(63, 72, 101, 1);

  &::before {
    background-color: #c4e8fd;
  }
}

.miniGuides-grid {
  grid-template-columns: 150px 200px 150px 150px;
  align-items: center;
  width: 100%;
}

@media screen and (min-width: 1400px) {
  .miniGuides-grid {
    grid-template-columns: 15vw auto auto 7vw;
  }
}
</style>
